import { Typography as MuiTypography } from '@mui/material';
import { TypographyProps } from './Typography.props';

export const Typography = ({
  children,
  typographyStyleForStorybookOnly: _typographyStyleForStorybookOnly,
  ...props
}: TypographyProps) => {
  // _typographyStyleForStorybookOnly is filtered out (only used for Storybook controls)
  return <MuiTypography {...props}>{children}</MuiTypography>;
};

export default Typography;
